const VALID_IMAGE_FORMATS = ["image/jpeg", "image/jpg", "image/png"];

const MAX_IMAGE_SIZE = 1024;

const validateFile = file => {
  const imageSize = Math.round(file.size / MAX_IMAGE_SIZE);
  if (VALID_IMAGE_FORMATS.indexOf(file.type) === -1) {
    return {
      error: true,
      message: "File format is not supported",
    };
  } else if (imageSize >= MAX_IMAGE_SIZE) {
    return {
      error: true,
      message: "File exceeds the maximum size of 1 MB",
    };
  }

  return { error: false };
};

export { validateFile };
